import { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { RotateCcw } from 'lucide-react';
import QRCode from 'react-qr-code';
import Logo from '../../assets/logo_klikin.png';
import Frame from '../../assets/frame.png';
import html2canvas from 'html2canvas';

export default function PageResult() {
  const [photo, setPhoto] = useState(null);
  const captureRef = useRef(null);

  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem('photobooth_data'));
    if (saved?.generated_photo) {
      setPhoto(saved.generated_photo);
    }
  }, []);

  const handleDownload = async () => {
    if (!photo) return;

    const res = await fetch(photo);
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = `dream-result-${Date.now()}.jpg`;
    a.click();

    URL.revokeObjectURL(url);
  };

  const handleDownloadCanvas = async () => {
    if (!captureRef.current) return;

    const canvas = await html2canvas(captureRef.current, {
      scale: 3, // kualitas lebih bagus
      useCORS: true,
      backgroundColor: null
    });

    const image = canvas.toDataURL('image/png');

    const link = document.createElement('a');
    link.href = image;
    link.download = `dream-result-${Date.now()}.png`;
    link.click();
  };

  const handleRestart = () => {
    localStorage.removeItem('photobooth_data');
    window.location.href = '/';
  };

  return (
    <div className="relative h-full w-full overflow-hidden bg-[#0f1020] text-white">
      {/* Background */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,#8b5cf620,transparent_55%)]" />
      <div className="absolute -top-40 left-1/2 h-[300px] w-[300px] -translate-x-1/2 rounded-full bg-violet-500/20 blur-3xl" />

      <div className="relative z-10 flex h-full flex-col px-6 py-8">
        {/* Header */}
        <div className="text-center">
          <p className="flex justify-center items-center text-xs font-bold tracking-[0.4em] text-violet-300">
            <img src={Logo} className="h-10 w-auto object-fit-contain" />
          </p>
          <motion.h1
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-3xl font-black uppercase tracking-wide mt-4">
            Your Dream Result
          </motion.h1>

          <p className="mt-2 text-xs text-zinc-400 uppercase tracking-[0.3em]">
            SCAN TO DOWNLOAD
          </p>
        </div>

        {/* Main */}
        <div className="flex flex-1 items-center justify-center">
          <motion.div

            className="flex flex-col items-center gap-5">
            {/* DOWNLOAD IMAGE INI canvas */}
            <div
              ref={captureRef}
              className="relative overflow-hidden h-[428px] w-[238px] bg-black">
              <img
                src={Frame}
                alt="frame"
                className="absolute top-0 left-0 h-[428px]  w-[238px] object-cover"
              />

              {photo && (
                <img
                  src={photo}
                  alt="result"
                  className="h-[420px]  w-[238px] rounded-[0px] object-contain"
                />
              )}

              {/* scan effect */}
              {/* <motion.div
                animate={{ y: ['-120%', '120%'] }}
                transition={{
                  repeat: Infinity,
                  duration: 2.8,
                  ease: 'linear'
                }}
                className="absolute left-0 top-0 h-[100px] w-full bg-gradient-to-b from-transparent via-white/10 to-transparent blur-xl"
              /> */}
            </div>

            {/* QR (CLICK TO DOWNLOAD) */}
            <motion.button
              whileTap={{ scale: 0.95 }}
              onClick={handleDownloadCanvas}
              className="flex flex-col items-center gap-2">
              <div className="rounded-xl bg-white p-3">
                <QRCode value={photo || 'NO_DATA'} size={90} />
              </div>

              <p className="text-[10px] uppercase tracking-[0.35em] text-violet-300">
                TAP QR TO DOWNLOAD
              </p>
            </motion.button>
          </motion.div>
        </div>

        {/* START OVER */}
        <div className="pb-2">
          <motion.button
            whileTap={{ scale: 0.97 }}
            onClick={handleRestart}
            className="flex h-[64px] w-full items-center justify-center gap-2 rounded-full bg-white/10 text-sm font-bold uppercase tracking-wide backdrop-blur">
            <RotateCcw size={18} />
            Start Over
          </motion.button>
        </div>
      </div>
    </div>
  );
}
